module.exports = __webpack_public_path__ + "static/img/default.210edea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/default.jpg
// module id = ZTHz
// module chunks = 1